import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getStates = async (params: any) => {
  const url = endpoints.PLACE + "/states";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getCities = async (params: any) => {
  const url = endpoints.PLACE + "/cities/" + params.state_id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getCity= async (id: any) => {
  const url = endpoints.PLACE + "/city/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getDistricts = async (params: any) => {
  const url = endpoints.PLACE + "/districts/" + params.city_id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getDistrict= async (id: any) => {
  const url = endpoints.PLACE + "/district/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getSubDistricts = async (params: any) => {
  const url = endpoints.PLACE + "/sub-districts/" + params.district_id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getSubDistrict= async (id: any) => {
  const url = endpoints.PLACE + "/sub-district/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const services = {
  getStates,
  getCities,
  getCity,
  getDistricts,
  getDistrict,
  getSubDistricts,
  getSubDistrict,
};

export default services;
